import { render, staticRenderFns } from "./CopyWeetButton.vue?vue&type=template&id=0b2f85d3&scoped=true"
import script from "./CopyWeetButton.vue?vue&type=script&lang=ts"
export * from "./CopyWeetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f85d3",
  null
  
)

export default component.exports